/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmailStats } from './V2/iris/models/EmailStats';
import type { ActiveAccountsStats } from './V2/gozer/models/ActiveAccountsStats';
import { request as __requestG } from './V2/gozer/core/request';

export class StatsService {
    /**
     * @param operatorId
     * @param districtId
     * @returns EmailStats
     * @throws ApiError
     */
     public static async statsVGetEmailsCount(
        operatorId?: string,
        districtId?: string | null,
        ): Promise<EmailStats> {
        const result = await __requestG({
            method: 'GET',
            path: `/IrisApi/api/v2/stats/email`,
            query: {
                'operatorId': operatorId,
                'districtId': districtId,
            },
        });
        return result.body;
    }
    /**
     * @param operatorId
     * @param districtId
     * @returns EmailStats
     * @throws ApiError
     */
     public static async statsVGetSMSCount(
        operatorId?: string,
        districtId?: string | null,
        ): Promise<EmailStats> {
        const result = await __requestG({
            method: 'GET',
            path: `/IrisApi/api/v2/stats/sms`,
            query: {
                'operatorId': operatorId,
                'districtId': districtId,
            },
        });
        return result.body;
    }

    /**
     * @param operatorId
     * @param districtId
     * @returns ActiveAccountsStats
     * @throws ApiError
     */
     public static async statsVGetActiveAccountsCount(
        operatorId?: string,
        districtId?: string | null,
        ): Promise<ActiveAccountsStats> {
        const result = await __requestG({
            method: 'GET',
            path: `/GozerApi/api/v2/stats`,
            query: {
                'operatorId': operatorId,
                'districtId': districtId,
            },
        });
        return result.body;
    }
}